import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  const navigate = useNavigate();

  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-12 sm:py-16 px-4">
        <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-muted flex items-center justify-center mb-4 sm:mb-6">
          <Icon name="Search" size={32} className="text-muted-foreground" strokeWidth={2} />
        </div>
        <h3 className="text-xl sm:text-2xl font-heading font-bold text-foreground mb-2 text-center">
          No Matching Entries
        </h3>
        <p className="text-sm sm:text-base text-muted-foreground text-center max-w-md mb-6">
          No symptom entries match your current filters. Try adjusting your filter criteria.
        </p>
        <Button
          variant="outline"
          size="lg"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
        >
          Clear All Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-12 sm:py-16 px-4">
      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-primary/10 flex items-center justify-center mb-4 sm:mb-6">
        <Icon name="FileText" size={32} className="text-primary" strokeWidth={2} />
      </div>
      <h3 className="text-xl sm:text-2xl font-heading font-bold text-foreground mb-2 text-center">
        Your Symptom History Starts Here
      </h3>
      <p className="text-sm sm:text-base text-muted-foreground text-center max-w-md mb-4">
        This is where all your daily check-ins will appear in a timeline view. Once you log your first symptom entry, you'll be able to:
      </p>
      
      {/* Feature list */}
      <div className="bg-muted/50 rounded-lg p-4 mb-6 max-w-md w-full">
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li className="flex items-start gap-2">
            <Icon name="CheckCircle2" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <span>View your symptom patterns over time</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="CheckCircle2" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <span>Track severity changes and triggers</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="CheckCircle2" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <span>Export reports for your doctor</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="CheckCircle2" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <span>Filter by date, symptom type, and severity</span>
          </li>
        </ul>
      </div>

      <Button
        variant="default"
        size="lg"
        onClick={() => navigate('/daily-check-in')}
        iconName="Plus"
        iconPosition="left"
      >
        Log Your First Entry
      </Button>
      
      <p className="text-xs text-muted-foreground text-center mt-4">
        🔒 All your data is securely encrypted and private
      </p>
    </div>
  );
};

export default EmptyState;